import React from 'react';
import { Popover, Button, Table, Select, Input } from 'antd';

import classnames from 'classnames';
import style from './index.scss';

// sample format for filter items
// [
//   {
//     logic: '=' || '!=' || '>' || '<' || 'like',
//     columnName: 'sampleName',
//     item: 'sample Item',
//   },
// ]

// sample format for column names
// [
//   {
//     columnName: 'sampleColumn',
//     columnLabel: 'sample label',
//   }
// ]

const { Option } = Select;

class FilterComponent extends React.Component {
  state = {
    filterItems: this.props.dataItems ? this.props.dataItems : [],
    isPopOverVisible: false,
    error: null
  };

  onChangeInputItem = (e, itemIndex) => {
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems
      .map((o) => {
        if (o.itemIndex !== itemIndex) {
          return o;
        } else {
          return {
            ...o,
            value: e.target.value
          };
        }
      })
      .filter((o) => o !== null);

    this.setState({
      filterItems: updatedFilterItems
    });
  };

  onChangeColumnName = (columnName, itemIndex) => {
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems
      .filter((o) => o !== null)
      .map((o) => {
        if (o.itemIndex !== itemIndex) {
          return o;
        } else {
          return {
            ...o,
            columnName: columnName
          };
        }
      });

    this.setState({
      filterItems: updatedFilterItems
    });
  };

  onChangeLogic = (logicValue, itemIndex) => {
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems
      .map((o) => {
        if (o.itemIndex !== itemIndex) {
          return o;
        } else {
          return {
            ...o,
            logic: logicValue
          };
        }
      })
      .filter((o) => o !== null);

    this.setState({
      filterItems: updatedFilterItems
    });
  };

  onApplyClick = () => {
    const { onFilterChange } = this.props;
    const { filterItems } = this.state;

    if (onFilterChange) {
      // flag to check if there is an invalid item
      let hasInvalidItem = false;
      filterItems?.forEach((item) => {
        const { columnName, logic, value } = item;
        if (!columnName || !logic || !value) {
          hasInvalidItem = true;
        }
      });

      // show error if have
      if (hasInvalidItem) {
        this.setState({
          error: 'Please make sure all fields are filled.'
        });
      } else {
        this.setState(
          {
            error: null
          },
          () => {
            onFilterChange(filterItems);
            this.onTogglePopoverVisibility();
          }
        );
      }
    }
  };

  onClearClick = () => {
    this.setState({
      filterItems: []
    });
  };

  onTogglePopoverVisibility = () => {
    const { isPopOverVisible } = this.state;
    this.setState({
      isPopOverVisible: !isPopOverVisible
    });
  };

  onChangeColumnName = (columnName, itemIndex) => {
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems
      .filter((o) => o !== null)
      .map((o) => {
        if (o.itemIndex !== itemIndex) {
          return o;
        } else {
          return {
            ...o,
            columnName: columnName
          };
        }
      });

    this.setState({
      filterItems: updatedFilterItems
    });
  };

  onChangeLogic = (logicValue, itemIndex) => {
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems
      .map((o) => {
        if (o.itemIndex !== itemIndex) {
          return o;
        } else {
          return {
            ...o,
            logic: logicValue
          };
        }
      })
      .filter((o) => o !== null);

    this.setState({
      filterItems: updatedFilterItems
    });
  };

  onApplyClick = () => {
    const { onFilterChange } = this.props;
    const { filterItems } = this.state;

    if (onFilterChange) {
      // flag to check if there is an invalid item
      let hasInvalidItem = false;
      filterItems?.forEach((item) => {
        const { columnName, logic, value } = item;
        if (!columnName || !logic || !value) {
          hasInvalidItem = true;
        }
      });

      // show error if have
      if (hasInvalidItem) {
        this.setState({
          error: 'Please make sure all fields are filled.'
        });
      } else {
        this.setState(
          {
            error: null
          },
          () => {
            onFilterChange(filterItems);
            this.onTogglePopoverVisibility();
          }
        );
      }
    }
  };

  onClearClick = () => {
    this.setState({
      filterItems: []
    });
  };

  onTogglePopoverVisibility = () => {
    const { isPopOverVisible } = this.state;
    this.setState({
      isPopOverVisible: !isPopOverVisible
    });
  };

  onChangeColumnName = (columnName, itemIndex) => {
    const { onFilterChange } = this.props;
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems
      .filter((o) => o !== null)
      .map((o) => {
        if (o.itemIndex !== itemIndex) {
          return o;
        } else {
          return {
            ...o,
            columnName: e
          };
        }
      });

    this.setState(
      {
        filterItems: updatedFilterItems
      },
      () => {
        if (onFilterChange) {
          onFilterChange(updatedFilterItems);
        }
      }
    );
  };

  onChangeLogic = (logicValue, itemIndex) => {
    const { onFilterChange } = this.props;
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems
      .map((o) => {
        if (o.itemIndex !== itemIndex) {
          return o;
        } else {
          return {
            ...o,
            logic: e
          };
        }
      })
      .filter((o) => o !== null);

    this.setState(
      {
        filterItems: updatedFilterItems
      },
      () => {
        if (onFilterChange) {
          onFilterChange(updatedFilterItems);
        }
      }
    );
  };

  addFilterItem = () => {
    const { filterItems } = this.state;

    this.setState({
      filterItems: [
        ...filterItems,
        {
          itemIndex: filterItems.length + 1
        }
      ]
    });
  };

  deleteFilterItem = (itemIndex) => {
    const { filterItems } = this.state;
    const updatedFilterItems = filterItems.map((o) => {
      if (o.itemIndex !== itemIndex) {
        return o;
      } else {
        return null;
      }
    });

    this.setState({
      filterItems: updatedFilterItems
    });
  };

  renderButtons = () => {
    return (
      <div className="row">
        <div className="col-md-3">{this.renderAddItemButton()}</div>
        <div className="offset-md-4 col-md-2">
          <Button onClick={this.onClearClick}>Clear</Button>
        </div>
        <div className="col-md-2">
          <Button
            onClick={this.onApplyClick}
            type="primary"
            className={style.applyButton}>
            Apply
          </Button>
        </div>
      </div>
    );
  };

  renderAddItemButton = () => {
    const { filterItems } = this.state;

    if (filterItems.length < 3) {
      return (
        <i
          onClick={this.addFilterItem}
          className={classnames(style.addButton, 'fa fa-plus')}></i>
      );
    }

    return null;
  };

  render() {
    const { columnNames } = this.props;
    const { filterItems, isPopOverVisible, error } = this.state;

    const columns = [
      {
        title: 'Filter',
        dataIndex: 'columnName',
        key: 'columnName',
        render: (text, record) => (
          <Select
            onChange={(e) => this.onChangeColumnName(e, record.itemIndex)}
            defaultValue={record.columnName}
            style={{ width: '150px' }}>
            {columnNames?.map((o) => {
              return <Option value={o.columnName}>{o.columnLabel}</Option>;
            })}
          </Select>
        )
      },
      {
        title: 'Logic',
        key: 'filterAction',
        render: (text, record) => (
          <Select
            onChange={(e) => this.onChangeLogic(e, record.itemIndex)}
            defaultValue={record.logic}
            style={{ width: '150px' }}>
            <Option value="=">equals to</Option>
            <Option value="!=">not equal to</Option>
            <Option value="like">like</Option>
            <Option value=">">greater than</Option>
            <Option value="<">less than</Option>
          </Select>
        )
      },
      {
        title: 'Item',
        key: 'value',
        render: (text, record) => (
          <Input
            placeholder="Input filter value"
            defaultValue={record.value}
            onChange={(e) => this.onChangeInputItem(e, record.itemIndex)}
          />
        )
      },
      {
        title: '',
        key: 'deleteAction',
        render: (text, record) => {
          return (
            <i
              onClick={() => this.deleteFilterItem(record.itemIndex)}
              className={classnames(style.deleteButton, 'fa fa-close')}></i>
          );
        }
      }
    ];

    const content = () => {
      return (
        <div>
          <Table
            style={{ minWidth: '500px' }}
            columns={columns}
            dataSource={filterItems}
            pagination={false}
          />
          <br />
          <br />
          {error ? <p style={{ color: 'red' }}>{error}</p> : null}
          <br />
          <br />
          {error ? <p style={{ color: 'red' }}>{error}</p> : null}
          <br />
          <br />
          {this.renderButtons()}
        </div>
      );
    };

    return (
      <Popover
        visible={isPopOverVisible}
        content={content}
        placement="bottom"
        trigger="click">
        <Button
          onClick={this.onTogglePopoverVisibility}
          className={style.filterButton}>
          <i className="fa fa-filter"></i>
        </Button>
      </Popover>
    );
  }
}

export default FilterComponent;
